import React from "react";

const cases = [
  {
    tag: "Industrial Sales Team",
    context: "BD team preparing for a major trade expo.",
    did: "Sales enablement sprint: approach, value pitch, objection handling, booth discipline, lead capture & follow-up.",
    impact: "Field-ready routines for the expo and the pipeline after it — not theory.",
  },
  {
    tag: "Dental Hospital — Digital Lab",
    context: "Hospital wanted in-house clear-aligner production — early in the segment.",
    did: "Hardware setup (3D printing, thermoforming) + team training on high-end CAD.",
    impact: "₹1 Cr+ profit contribution over 2–3 years from the new capability.",
  },
  {
    tag: "Industrial Distributor — US Brand",
    context: "Distributor of a large US industrial manufacturer; limited geographic & segment reach.",
    did: "Opened Gujarat as a new territory; built hospital-channel entry; mapped electronics & defence demand.",
    impact: "New territory live; hospital segment opened after ~20 years of limited traction; ~$600K opportunity identified.",
  },
];

export default function SelectedOutcomes() {
  return (
    <section
      id="outcomes"
      data-testid="selected-outcomes"
      className="px-6 md:px-12 lg:px-24 py-24 md:py-32 border-t border-sebyx-border bg-sebyx-surface/40"
    >
      <div className="flex items-center gap-3 mb-6">
        <span className="block w-8 h-px bg-sebyx-accent" />
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-sebyx-accent">
          [03] Selected Outcomes
        </span>
      </div>
      <h2
        data-testid="outcomes-headline"
        className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-sebyx-text leading-[1.05]"
      >
        Work that kept{" "}
        <span className="text-sebyx-accent italic font-light">producing</span>.
      </h2>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
        {cases.map((c, i) => (
          <div
            key={c.tag}
            data-testid={`outcome-card-${i}`}
            className="border border-sebyx-border bg-sebyx-bg p-7 flex flex-col"
          >
            <div className="h-0.5 w-10 bg-sebyx-accent mb-5" />
            <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-sebyx-accent font-semibold">
              {c.tag}
            </div>
            <div className="mt-5">
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-sebyx-muted">
                Context
              </div>
              <p className="font-body text-sm text-sebyx-muted mt-1.5 leading-relaxed">
                {c.context}
              </p>
            </div>
            <div className="mt-4">
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-sebyx-muted">
                What we did
              </div>
              <p className="font-body text-sm text-sebyx-text/90 mt-1.5 leading-relaxed">
                {c.did}
              </p>
            </div>
            <div className="mt-4 pt-4 border-t border-sebyx-border">
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-sebyx-accent">
                Impact
              </div>
              <p className="font-body text-sm font-semibold text-sebyx-text mt-1.5 leading-relaxed">
                {c.impact}
              </p>
            </div>
          </div>
        ))}
      </div>

      <p
        data-testid="outcomes-footer-line"
        className="mt-10 text-center font-display text-base md:text-lg italic text-sebyx-text/90"
      >
        Territory, new segments, and systems that keep producing after the
        engagement.
      </p>
    </section>
  );
}
